/*
 * Error Manager Component: It is responsible for rendering error modal.
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { observer } from 'mobx-react';
import { CQAppStore } from '../../../store/cq-app-store';
import { CQAppConstant } from '../../../app-constants';
import TemplateConfigurationController from '../../../components/template-configuration/template-config.controller';

/**
 * @export
 * @class ErrorManager
 * @extends Component
 */
const ErrorManagerComponent = () => {
    const { errorMessage, errorType, errorFlag, errorMessages, componentName } = CQAppStore.error;
    const templateConfigurationController = new TemplateConfigurationController();
    const history = useHistory();
    const cookie = new Cookies();
    const hideToast = () => {
        CQAppStore.error.hide();
        if (errorType === CQAppConstant.ERROR_SESSION) {
            logout();
        }
    };

    const logout = async () => {
        try {
            cookie.remove(CQAppConstant.JWT_KEY);
            cookie.remove(CQAppConstant.INSTANCE_URL);
            cookie.remove(CQAppConstant.VERSION_NUMBER);
            cookie.remove(CQAppConstant.LOGGED_IN_USERNAME);
            cookie.remove(CQAppConstant.LOGIN_URL);
            history.push(CQAppConstant.NAVIGATION.DEFAULT_PATH);
        } catch (error) {
            
        }
    };

    const publish = (templateName = componentName, submitForcefully = true) => {
        hideToast();
        templateConfigurationController.publishLWC(templateName, submitForcefully);
    }

    return (
        <>
            {
                errorFlag && errorType === CQAppConstant.ERROR_SESSION &&
                <div className="demo-only">
                    <section role="alertdialog"
                        className="slds-modal slds-fade-in-open slds-modal_prompt" aria-modal="true">
                        <div className="slds-modal__container">
                            <header className="slds-modal__header slds-theme_error slds-theme_alert-texture">
                                <button className="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close">
                                    <i className="cq-2x cq-icon-close"></i>
                                    <span className="slds-assistive-text">Close</span>
                                </button>
                                <h2 className="slds-text-heading_medium" id="prompt-heading-id">{errorType}</h2>
                            </header>
                            <div className="slds-modal__content slds-p-around_medium" id="prompt-message-wrapper">
                                <p>{errorMessage}</p>
                            </div>
                            <footer className="slds-modal__footer slds-theme_default">
                                <button className="slds-button slds-button_neutral"
                                    onClick={() => hideToast()}>Okay</button>
                            </footer>
                        </div>
                    </section>
                    <div className="slds-backdrop slds-backdrop_open"></div>
                </div >
            }
            {
                errorFlag && (errorType === CQAppConstant.DEPLOY_FAILED || errorType === CQAppConstant.SAME_BASE_CLASS_ERROR) &&
                <div className="demo-only">
                    <section role="alertdialog"
                        className="slds-modal slds-fade-in-open slds-modal_prompt" aria-modal="true">
                        <div className="slds-modal__container">
                            <header className="slds-modal__header slds-theme_error slds-theme_alert-texture">
                                <button className="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close">
                                    <i className="cq-2x cq-icon-close"></i>
                                    <span className="slds-assistive-text">Close</span>
                                </button>
                                <h2 className="slds-text-heading_medium" id="prompt-heading-id">{errorMessage}</h2>
                            </header>
                            <div className="slds-modal__content slds-p-around_medium" id="prompt-message-wrapper">
                                <ul>
                                    {
                                        errorMessages.map((error: string, index: number) => {
                                            return (<li key={index} >{`Reason ${index+1} :`} {error}</li>);
                                        })
                                    }
                                </ul>
                            </div>
                            <footer className="slds-modal__footer slds-theme_default">
                                <button className="slds-button slds-button_neutral"
                                    onClick={() => hideToast()}>Okay</button>
                            </footer>
                        </div>
                    </section>
                    <div className="slds-backdrop slds-backdrop_open"></div>
                </div >
            }
            {
                errorFlag && errorType !== CQAppConstant.ERROR_SESSION && errorType !== CQAppConstant.DEPLOY_FAILED && errorType !== CQAppConstant.BASE_CLASS_ALREADY_EXIST_WARNING && errorType !== CQAppConstant.COMPONENT_NAME_ALREADY_EXIST_WARNING && errorType !== CQAppConstant.SAME_BASE_CLASS_ERROR &&
                <div className="slds-notify_container">
                    <div className="slds-notify slds-notify_toast slds-theme_error" role="status">
                        <div className="slds-notify__content">
                            <h2 className="slds-text-heading_small ">{errorMessage}</h2>
                        </div>

                        <div className="slds-notify__close">
                            <button className="slds-button slds-button_icon slds-button_icon-inverse" title="Close"
                                onClick={() => hideToast()}>
                                <i className="cq-2x cq-icon-close"></i>
                            </button>
                        </div>
                    </div>
                </div>
            }
            {
                errorFlag && errorType === CQAppConstant.UNKNOWN_PUBLISH_ERROR &&
                <div className="slds-notify_container">
                <div className="slds-notify slds-notify_toast slds-theme_warning" role="status">
                    <div className="slds-notify__content">
                        <h2 className="slds-text-heading_small ">{errorMessage}</h2>
                        {
                            errorType === CQAppConstant.UNKNOWN_PUBLISH_ERROR &&
                            <p>
                                 Please click the link to view the deployment status.
                                <a target="_blank" href={`${cookie.get(CQAppConstant.INSTANCE_URL)}${CQAppConstant.PUBLISH_STATUS_URL}`} rel="noreferrer">View Status</a>
                            </p>
                        }
                    </div>
                
                    <div className="slds-notify__close">
                        <button className="slds-button slds-button_icon slds-button_icon-inverse" title="Close"
                            onClick={() => hideToast()}>
                            <i className="cq-2x cq-icon-close"></i>
                        </button>
                    </div>
                </div>
                </div>
            }
            {
                errorFlag && (errorType === CQAppConstant.BASE_CLASS_ALREADY_EXIST_WARNING || errorType === CQAppConstant.COMPONENT_NAME_ALREADY_EXIST_WARNING) &&
                <div className="demo-only">
                    <section role="alertdialog"
                        className="slds-modal slds-fade-in-open slds-modal_prompt" aria-modal="true">
                        <div className="slds-modal__container">
                            <header className="slds-modal__header slds-theme_warning slds-theme_alert-texture">
                                <button className="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close">
                                    <i className="cq-2x cq-icon-close"></i>
                                    <span className="slds-assistive-text">Close</span>
                                </button>
                                <h2 className="slds-text-heading_medium" id="prompt-heading-id" data-testid="error-title">{errorType}</h2>
                            </header>
                            <div className="slds-modal__content slds-p-around_medium" id="prompt-message-wrapper">
                                <p data-testid="error-message">{errorMessage}</p>
                            </div>
                            <footer className="slds-modal__footer slds-theme_default">
                                <button className="slds-button slds-button_neutral"
                                    onClick={() => publish()}>Continue</button>
                                <button className="slds-button slds-button_neutral"
                                    onClick={() => hideToast()}>Cancel</button>
                            </footer>
                        </div>
                    </section>
                    <div className="slds-backdrop slds-backdrop_open"></div>
                </div >
            }
        </>
    );
};



export default observer(ErrorManagerComponent);
